import React from "react";
import "./About_Us.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const About_Us = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="About_Us" ref={ref}>
      <div className="number_div_container">
        <div className="container number_div">

          <div className="number_holder">
            <h5 className="number">
              {inView && <CountUp end={10} duration={2} />}+
            </h5>
            <p className="text">Skill-Based Questions</p>
          </div>

          <div className="number_holder">
            <h5 className="number">
              {inView && <CountUp end={20} duration={2} />}+
            </h5>
            <p className="text">Industry Focused Questions</p>
          </div>

          <div className="number_holder">
            <h5 className="number">
              {inView && <CountUp end={3} duration={2} />}-Level
            </h5>
            <p className="text">Skill Classification</p>
          </div>

          <div className="number_holder">
            <h5 className="number">
              {inView && <CountUp end={100} duration={2} />}%
            </h5>
            <p className="text">Instant Results</p>
          </div>

        </div>
      </div>

      <div className="container">
        <div className="about_us_header">
          <h5>
            About <span>Us</span>
          </h5>

          <p className="about_text">
            This quiz is designed to evaluate your understanding of core
            concepts and measure your current skill level. It helps you identify
            your strengths, spot improvement areas, and understand where you
            stand. Based on your performance, you’ll receive instant results
            along with personalized recommendations to guide your learning
            journey and career growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About_Us;